import React from 'react';

export function useFeatureFlag({ key, defaultValue = false }) {
  return window.Shell.v1.featureFlags.useReactFeatureFlag(
    React,
    'ucde-portal',
    {
      key,
      defaultValue,
    },
  );
}
